<template>
  <header class="subHeader">
    <div class="content-header">DRAFTS</div>
    <div class="content-body">
      <a> Create new events and submit them to ADURO for approval. </a>
    </div>
    <div class="group-button-sub-header">
        <ButtonCreateNewEvent class="float-left" :item="btnSubmitAllEvent" />
        <ButtonCreateNewEvent class="float-right" :item="btnCreateEvent" />
      </div>
  </header>
</template>
<script>
import ButtonCreateNewEvent from '../commons/ButtonCreateNewEvent';
import 'vue-awesome/icons/plus-circle';
import 'vue-awesome/icons/plus';
import consts from '../../_consts';

export default {
  name: 'subHeaderDraft',
  methods: {
    sidebarToggle (e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-hidden');
    }
  },
  components: {
    ButtonCreateNewEvent
  },
  data () {
    return {
      btnCreateEvent: consts.subHeaderBtn.createNewEvent,
      btnSubmitAllEvent: consts.subHeaderBtn.submitAllEvent
    }
  }
};
</script>

<style lang="less">
@import '~@/styles/variables.less';

.group-button-sub-header{
  float: right;
  top: 120px;
  margin: 65px 20px 0 0;
}

.float-left{
  float: left;
}

.float-right{
  float: right;
}
</style>



// WEBPACK FOOTER //
// SubHeaderDraft.vue?73ff92b0